import React, { useCallback, useContext } from 'react'
import { Box, Text } from '@usap/uicomponents'
import { BoxWithBorder } from '@usap/widgets'

import seoIDs from '../../../config/seoIds'

import { GTM } from '../../helpers'

import { LocalContext } from '../../helpers/useLocalContext'
import { SearchContext } from '../common/context/SearchContextProvider'
import PageTypeIdentifier from '../../helpers/PageTypeIdentifier'

const itemPerPage = 'itemperpage'
const defaultPageItems = 15

const currentPage = 'currentpage'
const defaultCurrentPage = '1'

const trueValue = true

export default function DisplayItemsComponent(props) {
  const { toggleItemsPerPage } = props

  const {
    searchState: { products },
  } = useContext(SearchContext)

  const {
    resultCount: numberOfProducts = 0,
  } = products

  const { localContext } = useContext(LocalContext)
  const { history } = localContext

  const urlParams = new URLSearchParams(
    __BROWSER__ ? window.location.search : history.location.pathname,
  )

  const pageItemsCount = Number(urlParams.get(itemPerPage) || defaultPageItems)
  const pageNumber = Number(urlParams.get(currentPage) || defaultCurrentPage)

  const hasMinNumberOfProducts = pageItemsCount > numberOfProducts
  const shownRecords = hasMinNumberOfProducts ? numberOfProducts : pageItemsCount

  const { searchResultsTabView } = GTM

  const clickEventHandler = useCallback(
    count => {
      PageTypeIdentifier.setIdentifier(window?.pageType || null)
      if (!numberOfProducts < 15) {
        const categories = `Show ${count} result per page`
        searchResultsTabView({
          searchResultsCount: numberOfProducts,
          categories,
          itemsPerPageSelection: shownRecords,
          resultPageNumberSelection: pageNumber,
          clickText: count,
        })

        toggleItemsPerPage(itemPerPage, count)
      }
    },
    [
      numberOfProducts,
      pageNumber,
      searchResultsTabView,
      shownRecords,
      toggleItemsPerPage,
    ],
  )

  return (
    <Box
      id="showItemsBarContainer"
      direction="row"
      gap="small"
      align="center"
      justify="center"
    >
      <Text id="Text" size="small" color="dark-2" weight={500}>
        Display item:
      </Text>

      <Box id="showItemGrid" direction="row">
        {['left', 'none', 'right'].map((corner, index) => {
          const count = (index + 1) * 15
          const mapKey = `showItem-${corner}`

          return (
            <BoxWithBorder
              key={mapKey}
              id={seoIDs.showItemsBox.replace('{{key}}', index)}
              pointer={trueValue}
              selected={pageItemsCount === count}
              count={count}
              disabled={numberOfProducts < 15}
              round={corner !== 'none'}
              corner={corner}
              width="50px"
              margin={{ left: '-1px' }}
              weight={500}
              onClick={() => {
                clickEventHandler(count)
              }}
            />
          )
        })}
      </Box>
    </Box>
  )
}
